var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoApple = function SvgLogoApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 62"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#1D1D1B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#logo_apple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.278 29.897a6 6 0 0 1 .693-3.041 5.7 5.7 0 0 1 2.112-2.223 6.2 6.2 0 0 0-2.07-1.949 6 6 0 0 0-2.684-.795 6.6 6.6 0 0 0-2.857.551 13.6 13.6 0 0 1-2.104.72 6.2 6.2 0 0 1-1.898-.61 6.2 6.2 0 0 0-2.39-.61 5.75 5.75 0 0 0-3.09.956 6.74 6.74 0 0 0-2.286 2.534 9.8 9.8 0 0 0-1.091 4.766c.005 1.697.277 3.381.804 4.987.452 1.48 1.1 2.887 1.923 4.182a13.4 13.4 0 0 0 1.818 2.384c.284.343.634.619 1.029.809s.823.29 1.258.292a5.6 5.6 0 0 0 1.973-.583 5.45 5.45 0 0 1 2.286-.525 5.3 5.3 0 0 1 2.209.525 5.5 5.5 0 0 0 2.077.55 3.39 3.39 0 0 0 2.235-1.079q.438-.418.794-.914.429-.582.949-1.385.362-.58.714-1.247.36-.686.636-1.414.133-.303.233-.622c.07-.212.133-.428.208-.65a6 6 0 0 1-2.54-2.277 6.33 6.33 0 0 1-.94-3.347zM34.003 19.647a6.26 6.26 0 0 0 1.378-3.88v-.275q0-.139-.027-.275c-.715.06-1.41.277-2.039.637a5.7 5.7 0 0 0-1.78 1.469 5.87 5.87 0 0 0-1.402 3.74v.263q.001.133.026.264a4.16 4.16 0 0 0 2.17-.44 4.35 4.35 0 0 0 1.674-1.503"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_apple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.484 10.333h39.037V49.37H11.484z"
  })))));
};
export default SvgLogoApple;